import { ErrorResponse, ServerError } from '~/infra/ErrorResponse';
import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { OptionType } from '~/integrations/Accounting/AccountingCustomerDropdown/AccountingCustomerDropdown.utils';
const applyOneMapping = async (contactId, contactVersion, param, createContact, linkContact, showErrorToast, texts, errorTexts)=>{
    let { accounting, option, currentIntegratedId } = param;
    try {
        if ((option === null || option === void 0 ? void 0 : option.type) === OptionType.CreateNew) {
            await createContact({
                contactId,
                accounting
            });
            return true;
        }
        const newIntegratedId = (option === null || option === void 0 ? void 0 : option.type) === OptionType.Existing ? option.customer.id() : undefined;
        const isDirty = currentIntegratedId !== newIntegratedId;
        if (isDirty) {
            await linkContact({
                accounting,
                contactId,
                data: {
                    version: contactVersion,
                    integratedId: newIntegratedId
                }
            });
        }
        return true;
    } catch (err) {
        const errorResponse = new ErrorResponse(err);
        if (errorResponse.hasServerError(ServerError.QboSubscriptionInactive)) {
            showErrorToast(texts.qboSubscriptionInactive(), 'qbo-subscription-inactive-toast');
            return false;
        }
        const isDuplicateError = errorResponse.hasServerError(ServerError.DuplicateNameExists);
        showErrorToast(isDuplicateError ? texts.duplicateAccountingContact({
            accountingName: getAccountingDetails(accounting).fullName
        }) : errorTexts.unexpected(), isDuplicateError ? 'duplicate-contact-toast' : 'general-error-toast');
        return false;
    }
};
export const applyAccountingMapping = async (param)=>{
    let { contactId, contactVersion, selections, createContact, linkContact, showErrorToast, texts, errorTexts } = param;
    let allSucceeded = true;
    for (const selection of selections){
        const succeeded = await applyOneMapping(contactId, contactVersion, selection, createContact, linkContact, showErrorToast, texts, errorTexts);
        allSucceeded = allSucceeded && succeeded;
    }
    return allSucceeded;
};
